import { makeAutoObservable } from 'mobx';
import { enableStaticRendering } from 'mobx-react-lite';
import { option } from '../../components/CustomFieldComponent';
import { isSSR } from '../../utils/helpers';

enableStaticRendering(isSSR());

export interface ICustomizedOptions {
    fieldKey: string;
    options: option[];
}

export class TicketFormUtilStore {
    isUploadingAttachment: boolean;
    resetFileListTriggered: boolean;
    constructor() {
        this.isUploadingAttachment = false;
        this.resetFileListTriggered = false;

        // Call it here
        makeAutoObservable(this);
    }

    resetFileList = (state: boolean): void => {
        this.resetFileListTriggered = state;
    };

    setIsUploadingAttachment = (state: boolean): void => {
        this.isUploadingAttachment = state;
    };
}
